import { NavigateOptions, useNavigate } from 'react-router-dom';
import useUrlWithEnv from './useUrlWithEnv';

const useNavigateWithEnv = () => {
  const navigateBase = useNavigate();
  const getUrlWithEnv = useUrlWithEnv();

  const navigate = (to: string, options?: NavigateOptions, newTab?: boolean) =>
    newTab
      ? window.open(getUrlWithEnv(to), '_blank')
      : navigateBase(getUrlWithEnv(to), options);

  return navigate;
};

export default useNavigateWithEnv;
